export const isExists = (value) => value !== undefined && value !== null
export const isString = (value) => isExists(value) && typeof value === "string"

export const isNumber = (value) => hasText(value) && !isNaN(value)

export const hasText = (value) => isString(value) && value.trim().length > 0


export function parseFormDataTextToJsonString(text) {
    if (!text.includes("form-data")) {
        return JSON.stringify(text);
    } else {
        let formDataStr = text.split("form-data; name=");
        let objectArray = [];
        formDataStr.forEach(subString => {
            const data = subString.substring(subString.indexOf("\\"), subString.indexOf('--'))
                .replaceAll("\r\n\r\n", ":")
                .replaceAll("\r\n", "");
            objectArray.push(data)
        })
        return objectArray.join(' ');
    }
}

